/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CorrectiveActionSelectionDto } from './CorrectiveActionSelectionDto';
import {
    CorrectiveActionSelectionDtoFromJSON,
    CorrectiveActionSelectionDtoFromJSONTyped,
    CorrectiveActionSelectionDtoToJSON,
} from './CorrectiveActionSelectionDto';

/**
 * 
 * @export
 * @interface GetSessionCorrectiveActionsQueryVm
 */
export interface GetSessionCorrectiveActionsQueryVm {
    /**
     * 
     * @type {Array<CorrectiveActionSelectionDto>}
     * @memberof GetSessionCorrectiveActionsQueryVm
     */
    correctiveActions?: Array<CorrectiveActionSelectionDto> | null;
}

/**
 * Check if a given object implements the GetSessionCorrectiveActionsQueryVm interface.
 */
export function instanceOfGetSessionCorrectiveActionsQueryVm(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetSessionCorrectiveActionsQueryVmFromJSON(json: any): GetSessionCorrectiveActionsQueryVm {
    return GetSessionCorrectiveActionsQueryVmFromJSONTyped(json, false);
}

export function GetSessionCorrectiveActionsQueryVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSessionCorrectiveActionsQueryVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correctiveActions': !exists(json, 'correctiveActions') ? undefined : (json['correctiveActions'] === null ? null : (json['correctiveActions'] as Array<any>).map(CorrectiveActionSelectionDtoFromJSON)),
    };
}

export function GetSessionCorrectiveActionsQueryVmToJSON(value?: GetSessionCorrectiveActionsQueryVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correctiveActions': value.correctiveActions === undefined ? undefined : (value.correctiveActions === null ? null : (value.correctiveActions as Array<any>).map(CorrectiveActionSelectionDtoToJSON)),
    };
}

